module.exports = __webpack_public_path__ + "img/tag_fans.ded56c87.png";